import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-customer-layer-config',
  templateUrl: './customer-layer-config.component.html',
  standalone: false,
})
export class CustomerLayerConfigComponent {
  @Input() isLayerSelectionVisible: boolean = false
  @Input() isHistoryVisible: boolean = false

  constructor() {}

  toggleLayerSwitchVisibility() {
    this.isLayerSelectionVisible = !this.isLayerSelectionVisible
  }
}
